module.exports = __webpack_public_path__ + "media/pdf_missing/mini-van@3x-2bc89c95.svg";